import { createSlice } from "@reduxjs/toolkit";
import { AddSoftAsset, UpdateSoftAsset, GetSoftAssetList, GetSoftAssetDetail } from "services/softAsset/softAsset.service";
import { toast } from 'react-toastify';

export const softAssetAddSlice = createSlice({
  name: "softAssetAddSlice",
  initialState: {
    softAssetAdd: {},
    softAssetAddLoading: false,
    softAssetAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddSoftAsset.pending, (state) => {
      // toast.loading('We are adding the asset 🤯')
      state.softAssetAddLoading = true
    });

    builder.addCase(AddSoftAsset.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New asset added successfully 👌');

      state.softAssetAdd = action.payload
      state.softAssetAddLoading = false
      state.softAssetAddError = null
    });

    builder.addCase(AddSoftAsset.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the asset 😣")

      state.softAssetAddLoading = false
      state.softAssetAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const softAssetUpdateSlice = createSlice({
  name: "softAssetUpdateSlice",
  initialState: {
    softAssetUpdate: {},
    softAssetUpdateLoading: false,
    softAssetUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateSoftAsset.pending, (state) => {
      // toast.loading('We are updating the asset 🤯')
      state.softAssetUpdateLoading = true
    });

    builder.addCase(UpdateSoftAsset.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.softAssetUpdate = action.payload
      state.softAssetUpdateLoading = false
      state.softAssetUpdateError = null
    });

    builder.addCase(UpdateSoftAsset.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the asset 😣")

      state.softAssetUpdateLoading = false
      state.softAssetUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const softAssetListSlice = createSlice({
  name: "softAssetListSlice",
  initialState: {
    softAssetList: [],
    softAssetListLoading: false,
    softAssetListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetSoftAssetList.pending, (state) => {
      state.softAssetListLoading = true
    });

    builder.addCase(GetSoftAssetList.fulfilled, (state, action) => {
      toast.dismiss();

      state.softAssetList = action.payload
      state.softAssetListLoading = false
      state.softAssetListError = null
    });

    builder.addCase(GetSoftAssetList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the soft asset 😣")

      state.softAssetListLoading = false
      state.softAssetListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const softAssetDetailSlice = createSlice({
  name: "softAssetDetailSlice",
  initialState: {
    softAssetDetail: [],
    softAssetDetailLoading: false,
    softAssetDetailError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetSoftAssetDetail.pending, (state) => {
      state.softAssetDetailLoading = true
    });

    builder.addCase(GetSoftAssetDetail.fulfilled, (state, action) => {
      toast.dismiss();

      state.softAssetDetail = action.payload
      state.softAssetDetailLoading = false
      state.softAssetDetailError = null
    });

    builder.addCase(GetSoftAssetDetail.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the asset detail😣")

      state.softAssetDetailLoading = false
      state.softAssetDetailError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});